import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { LottieComponent } from '../lottie/lottie.component';

@Component({
    selector: 'finder-lottie-bg',
    templateUrl: './lottie-bg.component.html',
    styleUrls: ['./lottie-bg.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LottieComponent,
    ]
})
export class LottieBgComponent implements OnInit {
    @Input() data;
    @Input() onTriggerPlayback: Observable<boolean>;
    @Output() triggerPlayback = new EventEmitter<boolean>();

    constructor() { }

    ngOnInit() {
        this.handleTrigger();
    }

    private handleTrigger() {
        if (!this.onTriggerPlayback) {
            return;
        }

        this.onTriggerPlayback.subscribe(event => {
            if (!event) {
                return;
            }

            this.triggerPlayback.emit(event);
        });
    }
}
